@if (optionsReady()) {
  <ncp-table
    #medicalImages
    [(options)]="options"
  ></ncp-table>
}

<ncp-modal
  #previewMod
  [options]="previewModOptions()"
>
  <div class="d-flex flex-grow-1 justify-content-center align-items-center">
    @if (imageUrl()) {
      <img
        [src]="imageUrl()"
        alt="Medical image preview"
        style="width: 100%; height: 100%; object-fit: contain;"
      />
    }
  </div>
</ncp-modal>
